import { FontSizes, FontWeights } from '@fluentui/react';
export var getStyles = function (_props) {
    return {
        additionalContent: {
            lineHeight: '20px'
        },
        messageBody: {
            overflow: 'hidden',
            wordWrap: 'break-word',
            lineHeight: '20px'
        },
        actionLinks: {
            display: 'flex'
        },
        readMoreText: {
            paddingTop: '4px',
            marginRight: '16px',
            lineHeight: '24px',
            fontSize: FontSizes.size14,
            fontWeight: FontWeights.regular
        },
        attentionText: {
            paddingTop: '4px',
            lineHeight: '24px',
            fontSize: FontSizes.size14,
            fontWeight: FontWeights.regular,
            marginRight: '16px'
        }
    };
};
//# sourceMappingURL=NotificationBody.styles.js.map